import { useState, useEffect } from "react";
import { useGlobalContext } from "../../../../../../Context/Context";
import Button from "../../../../../Custom/Button/Button";
import axios from "axios";

const sluzbe = [
  { key: "hitna",        label: "Najbliža služba hitne pomoći" },
  { key: "zdravstvena",  label: "Najbliža zdravstvena ustanova" },
  { key: "trovanje",     label: "Najbliži centar za trovanja" },
  { key: "opekotine",    label: "Najbliži centar za opekotine" },
  { key: "policija",     label: "Najbliža policijska stanica" },
  { key: "vatrogasna",   label: "Najbliža vatrogasna služba" },
];

const emptyKontakti = sluzbe.reduce((acc, s) => {
  acc[`${s.key}_tel`] = "";
  acc[`${s.key}_adresa`] = "";
  return acc;
}, {});

const inputStyle = { height: "36px", padding: "0 8px", fontSize: "14px", width: "100%", boxSizing: "border-box" };
const labelStyle = { fontSize: "11px", fontWeight: "bold", marginBottom: "2px", display: "block" };

function KontaktiModal({ sredstvoId, data, zaposleniAll, onSaved, onClose }) {
  const { dictionary, baseUrl } = useGlobalContext();

  const [kontakti, setKontakti] = useState(emptyKontakti);
  const [prvaPomoc, setPrvaPomoc] = useState([]); // [ { employee_id, nivo, name, tel } ]

  useEffect(() => {
    if (!data) return;
    setKontakti({
      hitna_tel:          data.hitnaPomoc?.tel || "",
      hitna_adresa:       data.hitnaPomoc?.adresa || "",
      zdravstvena_tel:    data.zdravstvenaUstanova?.tel || "",
      zdravstvena_adresa: data.zdravstvenaUstanova?.adresa || "",
      trovanje_tel:       data.centarZaTrovanja?.tel || "",
      trovanje_adresa:    data.centarZaTrovanja?.adresa || "",
      opekotine_tel:      data.centarZaOpekotine?.tel || "",
      opekotine_adresa:   data.centarZaOpekotine?.adresa || "",
      policija_tel:       data.policijska?.tel || "",
      policija_adresa:    data.policijska?.adresa || "",
      vatrogasna_tel:     data.vatrogasna?.tel || "",
      vatrogasna_adresa:  data.vatrogasna?.adresa || "",
    });
    setPrvaPomoc(data.prvaPomoc || []);
  }, [data]);

  const handleKontaktChange = (key, value) => {
    setKontakti((prev) => ({ ...prev, [key]: value }));
  };

  const handleAddPP = (zaposleni) => {
    if (prvaPomoc.find((p) => String(p.employee_id) === String(zaposleni.id))) return;
    setPrvaPomoc((prev) => [...prev, { employee_id: zaposleni.id, name: zaposleni.name, tel: "", nivo: "O" }]);
  };

  const handleRemovePP = (employee_id) => {
    setPrvaPomoc((prev) => prev.filter((p) => String(p.employee_id) !== String(employee_id)));
  };

  const handleNivoChange = (employee_id, nivo) => {
    setPrvaPomoc((prev) => prev.map((p) => String(p.employee_id) === String(employee_id) ? { ...p, nivo } : p));
  };

  const handleSacuvaj = async () => {
    try {
      const { data: res } = await axios.post(`${baseUrl}/spp/save_kontakte.php`, {
        sredstvo_id: sredstvoId,
        kontakti,
        prva_pomoc: prvaPomoc.map((p) => ({ employee_id: p.employee_id, nivo: p.nivo })),
      });
      if (res.status === 200) { onSaved?.(); onClose(); }
      else alert("Greška pri čuvanju.");
    } catch (e) { console.error(e); }
  };

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px", padding: "20px", width: "700px", maxHeight: "90vh", overflowY: "auto" }}>
        
        {/* Osposobljeni za prvu pomoć */}
        <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>
          {dictionary["prvaPomocOsposobljeni"] || "Osposobljeni za prvu pomoć"}
        </div>

        {/* Select zaposlenog */}
        <div style={{ marginBottom: "10px" }}>
          <label style={labelStyle}>Dodaj zaposlenog:</label>
          <select style={{ ...inputStyle, width: "100%" }}
            onChange={(e) => {
              const z = zaposleniAll.find((z) => String(z.id) === e.target.value);
              if (z) handleAddPP(z);
              e.target.value = "";
            }}
            defaultValue="">
            <option value="" disabled>-- Odaberi --</option>
            {zaposleniAll.map((z) => (
              <option key={z.id} value={z.id}>{z.name}</option>
            ))}
          </select>
        </div>

        {/* Lista odabranih */}
        {prvaPomoc.length > 0 && (
          <table style={{ width: "100%", marginBottom: "20px", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ padding: "5px", textAlign: "left", backgroundColor: "#eee" }}>Ime</th>
                <th style={{ padding: "5px", textAlign: "center", backgroundColor: "#eee", width: "80px" }}>Nivo</th>
                <th style={{ padding: "5px", width: "40px", backgroundColor: "#eee" }}></th>
              </tr>
            </thead>
            <tbody>
              {prvaPomoc.map((pp) => (
                <tr key={pp.employee_id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ padding: "5px" }}>{pp.name}</td>
                  <td style={{ padding: "5px", textAlign: "center" }}>
                    <select value={pp.nivo} onChange={(e) => handleNivoChange(pp.employee_id, e.target.value)}
                      style={{ height: "32px", padding: "0 4px", fontSize: "14px" }}>
                      <option value="O">O</option>
                      <option value="H">H</option>
                    </select>
                  </td>
                  <td style={{ padding: "5px", textAlign: "center", cursor: "pointer", fontWeight: "bold" }}
                    onClick={() => handleRemovePP(pp.employee_id)}>✕</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Kontakti službi */}
        <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>Kontakti službi</div>
        {sluzbe.map((s) => (
          <div key={s.key} style={{ marginBottom: "12px" }}>
            <div style={{ fontWeight: "bold", fontSize: "13px", marginBottom: "4px", backgroundColor: "#eee", padding: "4px 6px" }}>{s.label}</div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ width: "30%" }}>
                <label style={labelStyle}>Telefon</label>
                <input style={inputStyle} value={kontakti[`${s.key}_tel`]}
                  onChange={(e) => handleKontaktChange(`${s.key}_tel`, e.target.value)} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Adresa</label>
                <input style={inputStyle} value={kontakti[`${s.key}_adresa`]}
                  onChange={(e) => handleKontaktChange(`${s.key}_adresa`, e.target.value)} />
              </div>
            </div>
          </div>
        ))}

        {/* Dugmad */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
          <div onClick={onClose}>
            <Button activation={true} style={{ padding: "8px 30px", fontWeight: "bold" }}>
              {dictionary["odustani"]}
            </Button>
          </div>
          <div onClick={handleSacuvaj}>
            <Button activation={true} style={{ padding: "8px 30px", fontWeight: "bold" }}>
              {dictionary["sacuvaj"]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KontaktiModal;